import React from 'react';
import styled from '@emotion/styled';
import { space, width } from 'styled-system';

import { useLocalization } from '../../providers/LocaleProvider';
import { aspectRatio, objectFit } from '../../theme/system-utilities';
import hcBanner from './hc-banner.png';

const Image = styled.img`
  ${width};
  ${objectFit};
  ${space};
  ${aspectRatio};
`;

const imageStyles = {
  width: 1,
  mb: 'sp_12',
  objectFit: 'cover',
  aspectRatio: '4 / 1',
};

export const HomeClubBanner = () => {
  const { t } = useLocalization();

  return <Image src={hcBanner.src} alt={t('h24_hc_modal_title')} {...imageStyles} />;
};
